var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9766 10L18.9141 6.0625C19.4141 5.5625 19.4141 4.8125 18.9141 4.3125L16.2891 1.6875C15.7891 1.1875 15.0391 1.1875 14.5391 1.6875L10.5391 5.5625L6.60156 1.625C6.10156 1.125 5.35156 1.125 4.85156 1.625L2.16406 4.25C1.66406 4.75 1.66406 5.5 2.16406 6L6.10156 10L1.78906 14.3125V18.75H6.22656L10.5391 14.4375L14.4766 18.375C14.9766 18.875 15.7266 18.875 16.2266 18.375L18.8516 15.75C19.3516 15.25 19.3516 14.5 18.8516 14L14.9766 10ZM15.4141 2.5L18.0391 5.125L14.1016 9.0625L11.4766 6.4375L15.4141 2.5ZM5.66406 17.5H3.03906V14.875L6.97656 10.9375L9.60156 13.5625L5.66406 17.5ZM15.4141 17.5L3.03906 5.125L5.66406 2.5L7.85156 4.6875L6.53906 6L7.41406 6.875L8.72656 5.5625L11.3516 8.1875L10.0391 9.5L10.9141 10.375L12.2266 9.0625L14.8516 11.6875L13.6641 13.0625L14.5391 13.9375L15.8516 12.625L18.0391 14.8125L15.4141 17.5Z",
    fill: "#9C4900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/tool.503c969df6343fbf9c39243e5ccf2dac.svg";
export { ForwardRef as ReactComponent };